<template>
    <div
        class="NameSystemQuizView"
        @mousemove="drag"
        @mouseup="dragEnd"
        @mouseleave="dragEnd"
        @touchmove="drag"
        @touchend="dragEnd"
    >
        <div class="top-part-wrapper">
            <div class="progress-bar-wrapper">
                <div class="progress-bar" :style="{ width: percentageProgress + '%' }" />
            </div>

            <div class="exit-button-wrapper" @click="$router.go(-1)">{{ $t('systems.exit') }}</div>
            <h2>{{ $t('systems.instruction') }}</h2>
            <div class="drop-boxes">
                <div
                    v-for="name in matchBoxNumbers"
                    :key="name"
                    :number="name"
                    class="drop-box"
                    @mouseenter="iluminateTile"
                    @mouseleave="resetIluminationFromTile"
                >
                    {{ name }}
                </div>
            </div>
        </div>
        <div class="bottom-part-wrapper">
            <div v-if="stepItems.length" class="carousel-rail">
                <div
                    v-for="item in slideItems"
                    :key="item[0]"
                    :number="item[0]"
                    class="shape-wrapper"
                    @mousedown="dragStart"
                    @touchstart="dragStart"
                >
                    {{ item[0] }}
                </div>
            </div>
            <div v-if="carouselSlidesCount > 1" class="carousel-pagination">
                <div
                    v-for="i in carouselSlidesCount"
                    :key="i"
                    :class="{ active: i === carousel.activeSlideIndex + 1 }"
                    class="pagination-dot"
                    @click="carousel.activeSlideIndex = i - 1"
                />
            </div>
        </div>
    </div>
</template>

<script>
import quizMixin from './quiz.mixin';
import dragAndDropMixin from './dragAndDrop.mixin';

export default {
    mixins: [quizMixin, dragAndDropMixin],

    computed: {
        group() {
            return this.system.groups.find(
                group => group.name === this.routeStringToName(this.$route.params.groupName)
            );
        },

        journey() {
            return this.group.journeys.find(
                journey => journey.name === this.routeStringToName(this.$route.params.journeyName)
            );
        },

        stepItems: {
            get: function () {
                return this.step.data.map(item => item);
            },
            set: function (newArr) {
                this.step.data = newArr;
            }
        }
    },

    mounted() {
        this.setMatchBoxesNumbers();
        this.shuffleStepItems();

        console.log(this.slideItems);
    },

    methods: {
        setMatchBoxesNumbers() {
            this.matchBoxNumbers = [...this.stepItems.map(item => item[0])];
        },

        shuffleStepItems() {
            this.stepItems = this.stepItems.sort(() => 0.5 - Math.random());
        },

        removeMatchedItemFromSelectArea() {
            this.stepItems = this.stepItems.filter(item => item[0] !== this.selectedItemNumber);
        }
    }
};
</script>

<style lang="scss" scoped>
.NameSystemQuizView {
    width: 375px;
    min-height: 809px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px;
    .progress-bar-wrapper {
        height: 10px;

        .progress-bar {
            transition: 0.5s;
            background: white;
            height: 100%;
            width: 0;
        }
    }
    .exit-button-wrapper {
        text-align: right;
        margin-top: 10px;
        color: hsla(0, 0%, 100%, 0.5);
    }
    h2 {
        font-size: 21px;
        font-weight: normal;
        text-align: center;
        margin-top: 30px;
    }
    .drop-boxes {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        .drop-box {
            min-width: 75px;
            min-height: 75px;
            max-width: 75px;
            max-height: 75px;
            border: 1px dashed hsla(0, 0%, 100%, 0.5);
            border-radius: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: hsla(0, 0%, 100%, 0.5);
            margin: 7.5px;
            transition: 0.5s;
            .numbershape {
                width: 100%;
                height: 100%;
                border-radius: 10px;
                background-color: white;
            }
        }
    }
    .bottom-part-wrapper {
        position: relative;

        .carousel-rail {
            display: flex;
            background: hsla(0, 0%, 100%, 0.5);
            padding: 5px;
            margin-top: 20px;
            border-radius: 10px;
            height: 75px;
            .shape-wrapper {
                width: calc(20% - 5px);
                border-radius: 10px;
                margin-right: 5px;
                background-color: white;
                color: black;
                font-size: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                .numbershape {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .carousel-pagination {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            .pagination-dot {
                width: 10px;
                height: 10px;
                background: hsla(0, 0%, 100%, 0.5);
                margin: 5px;
                border-radius: 50%;
                &.active {
                    background: white;
                }
            }
        }
    }
}
</style>
